const file = {
	attrs: {
		href: { default: null },
		isFile: { default: true },
		resourcePath: { default: null },
		class: { default: null },
	},
};

export default file;
